import { Reveal } from "@/components/Reveal";
import { HeroContent, HeroImageUrl, buildWhatsAppUrl } from "@/data/SiteContent";

export default function Hero() {
  return (
    <section id="inicio" className="relative flex min-h-[94vh] items-center overflow-hidden bg-ink">
      <img
        src={HeroImageUrl}
        alt="Interior elegante de un despacho jurídico moderno con iluminación cálida"
        className="absolute inset-0 h-full w-full object-cover opacity-35"
        fetchPriority="high"
        width={1920}
        height={1080}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/55 to-ink" />

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-24 pt-36 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold">
            {HeroContent.Overline}
          </p>
          <div className="mt-5 h-px w-16 bg-gold/70" aria-hidden="true" />
          <h1
            data-testid="hero-headline"
            className="mt-6 max-w-3xl font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            {HeroContent.Title}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
            {HeroContent.Subtitle}
          </p>
          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <a
              href="#servicios"
              data-testid="hero-cta-services"
              className="border border-white/40 px-8 py-3.5 text-center text-sm font-medium tracking-wide text-white transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              Nuestros servicios
            </a>
            <a
              href={buildWhatsAppUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="bg-gold px-8 py-3.5 text-center text-sm font-medium tracking-wide text-ink transition-colors duration-300 hover:bg-gold-dark hover:text-white"
            >
              Agendar una cita
            </a>
          </div>
        </Reveal>
      </div>

      <div
        className="absolute bottom-0 left-1/2 h-14 w-px -translate-x-1/2 bg-gradient-to-b from-transparent to-gold/70"
        aria-hidden="true"
      />
    </section>
  );
}
